// openClaw
import { default as httpInstance } from '@/jmHttp/index';
import { openClaw } from '@/jmHttp/interface';

// 获取分配的虚拟机
export const getAssignedMachine = async (data, config = {}) => {
  return await httpInstance.post(openClaw.getAssignedMachine, data, config);
};

// 初始化当前登录用户的 Sandbox
export const initSandbox = async (data, config = {}) => {
  return await httpInstance.post(openClaw.initSandbox, data, config);
};

// 检查是否需要升级 copaw
export const needUpdateVersion = async (data, config = {}) => {
  return await httpInstance.get(openClaw.needUpdateVersion, data, config);
};

// 升级 copaw 到最新版本
export const updateCopawVersion = async (data, config = {}) => {
  return await httpInstance.get(openClaw.updateCopawVersion, data, config);
};

// 导入技能
export const importSkill = async (data, config = {}) => {
  return await httpInstance.post(openClaw.importSkill, data, config);
};

// 获取 MCP 工具；返回 data.tools[]：{ name, desc, inputSchema }
export const getMcpTools = async (data, config = {}) => {
  return await httpInstance.post(openClaw.getMcpTools, data, config);
};

// 检查是否有投研龙虾资源(分配了云电脑)
export const hasAvailableResource = async (data, config = {}) => {
  return await httpInstance.get(openClaw.hasAvailableResource, data, config);
};

// 获取快速提问
export const quickQuestions = async (data, config = {}) => {
  return await httpInstance.get(openClaw.quickQuestions, data, config);
};

/** 云电脑资源总览（exchangePackages 兑换档位等） */
export const getCopawResourceOverview = async (data, config = {}) => {
  return await httpInstance.get(openClaw.resourceOverview, data, config);
};

/** 云电脑兑换时长 */
export const postCopawExchangeDuration = async (data, config = {}) => {
  return await httpInstance.post(openClaw.exchangeDuration, data, config);
};
